import { css } from "emotion";

export const content = css`
  padding: 10px 20px 0;
`;

export const input = css`
  &:not(:first-of-type) {
    margin-top: 20px;
  }

  &:last-of-type {
    margin-bottom: 40px;
  }

  & > :first-child {
    margin-bottom: 10px;
  }
`;

export const picker = css`
  width: 146px;
`;

export const button = css`
  width: 100%;
`;
